// PlannerItemDate Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'

class PlannerItemDate extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      totalRangeDays: PropTypes.number,
      onChange: PropTypes.func,
      index: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      item: null,
      totalRangeDays: 0,
      onChange: null,
      index: 0
    }
  }

  render () {
    const { item, index } = this.props

    return (
      <div className='planner-itemdate'>{this._renderClient(item, index)}</div>
    )
  }

  /* Private function */
  _renderRowInner (object, bShowMileStone) {
    const totalRangeDays = this.props.totalRangeDays
    const ranges = totalRangeDays > 0 && object.ranges ? object.ranges : []
    const milestones =
      bShowMileStone && object.milestones ? object.milestones : []

    return (
      <div className='inner'>
        <div className='rangeitems'>
          {ranges.map((rangeObj, idx) => {
            const dateDiff = rangeObj.end - (rangeObj.start - 1)
            const colStyle = {
              width: `${((dateDiff || 1) / totalRangeDays) * 100}%`,
              left: `${((rangeObj.start - 1) / totalRangeDays) * 100}%`
            }
            return <div key={idx} className='dayitem' style={colStyle} />
          })}
          {milestones.map(
            (milestone) =>
              milestone.rangeIndex >= 0 && (
                <div
                  className='phasemilestone'
                  style={{
                    left: `calc(${
                      (milestone.rangeIndex / totalRangeDays) * 100
                    }% - 12.5px)`
                  }}
                >
                  <IconButton
                    className='milestone'
                    size='normal'
                    type='primary'
                    multilingual={false}
                    tooltip={milestone.title}
                    tooltipPosition='top'
                    icon='planner-viewmilestone'
                    canHover={false}
                  />
                </div>
              )
          )}
        </div>
      </div>
    )
  }

  _renderClient (client, idx) {
    return (
      <div className='client' key={idx}>
        {this._renderRowInner(client, false)}
        {client.expanded && (
          <div className='client-cont'>
            {client.projects.map((project, idx) =>
              this._renderProject(project, idx)
            )}
          </div>
        )}
      </div>
    )
  }

  _renderProject (project, idx) {
    return (
      <div className='project' key={idx}>
        {this._renderRowInner(project, false)}
        {project.expanded && (
          <div className='project-cont'>
            {project.phases.map((phase, idx) => this._renderPhase(phase, idx))}
          </div>
        )}
      </div>
    )
  }

  _renderPhase (phase, idx) {
    if (phase.activities.length <= 0) {
      return null
    }

    return (
      <div className='phase' key={idx}>
        {this._renderRowInner(phase, true)}
        {phase.expanded && (
          <div className='phase-cont'>
            {phase.activities.map((activity, idx) =>
              this._renderActivity(activity, idx)
            )}
          </div>
        )}
      </div>
    )
  }

  _renderActivity (activity, idx) {
    return (
      <div className='activity' key={idx}>
        {this._renderRowInner(activity, false)}
        {activity.expanded && (
          <div className='activity-cont'>
            {activity.tasks.map((task, idx) => this._renderTask(task, idx))}
          </div>
        )}
      </div>
    )
  }

  _renderTask (task, idx) {
    return (
      <div className='task' key={idx}>
        {this._renderRowInner(task)}
      </div>
    )
  }
}

export default PlannerItemDate
